import { Breakpoint, Dialog as MuiDialog } from "@mui/material";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import UppercaseButton from "../UppercaseButton/UppercaseButton";
import { CANCEL } from "../../utility/TextLabels";

type DialogProps = {
  title: string;
  open: boolean;
  customWidth?: Breakpoint;
  onClose: () => void;
  onSubmit: () => void;
  isSubmitEnabled: boolean;
  children?: React.ReactNode;
};

const Dialog: React.FC<DialogProps> = ({
  title,
  open,
  customWidth,
  onClose,
  onSubmit,
  isSubmitEnabled,
  children,
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth={customWidth ?? "md"}
      fullWidth={true}
    >
      <DialogTitle
        fontFamily="Lato"
        fontSize="30px"
        fontStyle="normal"
        fontWeight={500}
        lineHeight="normal"
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {children}
        <Box
          sx={{ marginTop: 2, display: "flex", flexDirection: "row", gap: 2 }}
        >
          <UppercaseButton
            color="primary"
            onClick={onSubmit}
            disabled={!isSubmitEnabled}
          >
            {title}
          </UppercaseButton>
          <UppercaseButton color="secondary" onClick={onClose}>
            {CANCEL}
          </UppercaseButton>
        </Box>
      </DialogContent>
    </MuiDialog>
  );
};

export default Dialog;
